import * as React from 'react';
import { useRecoilValue } from 'recoil';
import IconService from '../../../Services/IconService';
import { IVehicleWithData } from '../../Vehicles/types';
import { mapInfoWindowChristmasIconsAtom } from '../ToolbarLayer/VehicleChipsControl/InfoWindowState';
import Config from '../../../../config';

interface SvgIconProps {
  vehicle: IVehicleWithData;
  isSelected?: boolean;
  forceVehicleTypeId?: number;
}

function SvgIcon(props: SvgIconProps): JSX.Element | null {
  const christmasIcons = useRecoilValue(mapInfoWindowChristmasIconsAtom);

  if (!props.vehicle || !props.vehicle.position) {
    return null;
  }
  // const svgData = IconService.getSpaceInvaderIcon(
  const svgData = IconService.getVehicleIcon(
    props.forceVehicleTypeId || props.vehicle.vehicleTypeId,
    props.vehicle.status && props.vehicle.drivingMode === 'business'
      ? props.vehicle.status
      : props.vehicle.drivingMode === 'private'
        ? 'PRIVATE'
        : 'UNKNOWN',
    props.vehicle.position.angle,
    true,
    1,
    props.forceVehicleTypeId ? false : props.isSelected,
    { christmasIcons: christmasIcons && Config.festivities.christmas.enabled }
  );

  // const rotate = `rotate(${props.vehicle.position.angle}, 20, 20)`;

  // if (props.isSelected) {
  //   return (
  //     <svg
  //       height="40px"
  //       width="40px"
  //       version="1.1"
  //       id="Layer_1"
  //       xmlns="http://www.w3.org/2000/svg"
  //       xmlnsXlink="http://www.w3.org/1999/xlink"
  //       viewBox="0 0 512 512"
  //       xmlSpace="preserve"
  //       transform={rotate}
  //     >
  //       <path
  //         style={{ fill: `#fff` }}
  //         stroke={`#${Config.statusColor[props.vehicle.status].stroke}`}
  //         // stroke="black"
  //         strokeWidth="15"
  //         d="M469.344,266.664v-85.328h-42.656v-42.672H384v-21.328h42.688v-64h-64v42.656H320v42.672H192V95.992
  //     h-42.656V53.336h-64v64H128v21.328H85.344v42.672H42.688v85.328H0v149.328h64v-85.328h21.344v85.328H128v42.672h106.688v-64h-85.344
  //     v-21.328h213.344v21.328h-85.344v64H384v-42.672h42.688v-85.328H448v85.328h64V266.664H469.344z M192,245.336h-64v-64h64V245.336z
  //      M384,245.336h-64v-64h64V245.336z"
  //       />
  //     </svg>
  //   );
  // }

  // return (
  //   <svg
  //     height="40px"
  //     width="40px"
  //     version="1.1"
  //     id="Layer_1"
  //     xmlns="http://www.w3.org/2000/svg"
  //     xmlnsXlink="http://www.w3.org/1999/xlink"
  //     viewBox="0 0 512 512"
  //     xmlSpace="preserve"
  //     transform={rotate}
  //   >
  //     <path
  //       style={{ fill: `#${Config.statusColor[props.vehicle.status].fill}` }}
  //       stroke={`#${Config.statusColor[props.vehicle.status].stroke}`}
  //       // stroke="black"
  //       strokeWidth="15"
  //       d="M469.344,266.664v-85.328h-42.656v-42.672H384v-21.328h42.688v-64h-64v42.656H320v42.672H192V95.992
  //   h-42.656V53.336h-64v64H128v21.328H85.344v42.672H42.688v85.328H0v149.328h64v-85.328h21.344v85.328H128v42.672h106.688v-64h-85.344
  //   v-21.328h213.344v21.328h-85.344v64H384v-42.672h42.688v-85.328H448v85.328h64V266.664H469.344z M192,245.336h-64v-64h64V245.336z
  //    M384,245.336h-64v-64h64V245.336z"
  //     />
  //   </svg>
  // );
  return <img src={svgData} alt="" width="50" height="50" />;
}

export default SvgIcon;
